<div class="recuperar">
  <div class="recuperar__card">
    @if (estado() !== 'listo') {
      <h2 class="recuperar__title">Recuperar contraseña</h2>
      <p class="recuperar__text">
        Ingresa tu usuario o correo y te enviaremos un enlace para restablecer tu contraseña.
      </p>

      <form [formGroup]="form" (ngSubmit)="enviar()" class="recuperar__form">
        <mat-form-field appearance="outline" class="recuperar__field">
          <mat-label>Usuario o correo</mat-label>
          <input matInput formControlName="identificador" autocomplete="username" />
          @if (form.get('identificador')?.touched && form.get('identificador')?.invalid) {
            <mat-error>El usuario o correo es obligatorio</mat-error>
          }
        </mat-form-field>

        <button
          mat-flat-button
          color="primary"
          type="submit"
          class="recuperar__submit"
          [disabled]="estado() === 'enviando'"
        >
          @if (estado() === 'enviando') {
            <mat-spinner diameter="20"></mat-spinner>
          } @else {
            Enviar enlace
          }
        </button>
      </form>

      <a class="recuperar__link" (click)="irAlLogin()">Volver al inicio de sesión</a>
    } @else {
      <svg
        class="recuperar__icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
      >
        <rect x="2" y="4" width="20" height="16" rx="2"></rect>
        <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
      </svg>
      <h2 class="recuperar__title">Revisa tu correo</h2>
      <p class="recuperar__text">
        Si la cuenta existe, te enviamos un enlace para restablecer tu contraseña. Revisa tu bandeja
        de entrada (y la carpeta de spam).
      </p>
      <button mat-flat-button color="primary" class="recuperar__submit" (click)="irAlLogin()">
        Volver al inicio de sesión
      </button>
    }
  </div>
</div>
